import { filter, flatMap, get, includes, isEqual, keys, map } from 'lodash/fp';
import { NEEDS_PRODUCT_TYPE_SLUG, PRODUCTS_BY_NEEDS, PRODUCTS_BY_PARENT } from '@ahmdigital/constants';

import excludeChoosableForNeeds from '../exclude-choosable-for-needs';
import filterIdsByExcess from '../filter-ids-by-excess';
import getSaleableProductIdsKeyedByType from '../get-saleable-product-ids-keyed-by-type';

const { EXTRAS, HOSPITAL, PACKAGE } = NEEDS_PRODUCT_TYPE_SLUG;

const getAllSaleableProducts = () => {
  const allSaleableProductsIds = getSaleableProductIdsKeyedByType();
  // @ts-expect-error - Automatic, Please fix when editing this file
  const saleableProductIdsHospital = allSaleableProductsIds.hospital;
  // @ts-expect-error - Automatic, Please fix when editing this file
  const saleableProductIdsExtras = allSaleableProductsIds.extras;
  // @ts-expect-error - Automatic, Please fix when editing this file
  const saleableProductIdsPackage = allSaleableProductsIds.package;
  const saleableProductIdsCombined = flatMap((hospitalId) =>
    map((extrasId) => `${hospitalId}-${extrasId}`)(saleableProductIdsExtras),
  )(saleableProductIdsHospital);
  return [
    // @ts-expect-error - Automatic, Please fix when editing this file
    ...saleableProductIdsExtras,
    // @ts-expect-error - Automatic, Please fix when editing this file
    ...saleableProductIdsHospital,
    // @ts-expect-error - Automatic, Please fix when editing this file
    ...saleableProductIdsPackage,
    ...saleableProductIdsCombined,
  ];
};

// @ts-expect-error - Automatic, Please fix when editing this file
const getProductIdsFromNeeds = ({ hospitalExcess, needsType, needsProductType }) => {
  const listOfBundles = get(`${needsType}.${needsProductType}`)(PRODUCTS_BY_NEEDS);
  const bundlesMappedToProductIds = flatMap((bundle) => {
    const productTypes = keys(bundle);

    // has only an extras product
    if (isEqual(productTypes, [EXTRAS])) {
      // @ts-expect-error - Automatic, Please fix when editing this file
      return bundle[EXTRAS];
    }

    // hospital or package product
    // @ts-expect-error - Automatic, Please fix when editing this file
    const parentProduct = bundle[HOSPITAL] || bundle[PACKAGE];
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly "boost-basic-plus": readonly ["boost-basic-plus-excess-500", "boost-basic-plus-excess-750"]; readonly "boost-flexi-basic-plus": readonly ["boost-flexi-basic-plus-excess-500", "boost-flexi-basic-plus-excess-750"]; ... 32 more ...; readonly "simple-bronze-plus": readonly [...]; }'.
    const productIds = PRODUCTS_BY_PARENT[parentProduct];
    const idsToLoad = hospitalExcess ? filterIdsByExcess({ hospitalExcess, productIds }) : productIds;

    // @ts-expect-error - Automatic, Please fix when editing this file
    const hasComplementaryProduct = Boolean(bundle[EXTRAS]);
    if (!hasComplementaryProduct) {
      return idsToLoad;
    }

    // if it is a soft bundle concat the extras to the parent id
    // @ts-expect-error - Automatic, Please fix when editing this file
    return map((productId) => `${productId}-${bundle[EXTRAS]}`)(idsToLoad);
  })(listOfBundles);

  const productIdsAdjustedForChoosable = excludeChoosableForNeeds({
    needsProductType,
    needsType,
    productIds: bundlesMappedToProductIds,
  });

  // Ensure we're not returning a list with non-saleable products in it.
  return filter((productId) => includes(productId, getAllSaleableProducts()))(productIdsAdjustedForChoosable);
};

export default getProductIdsFromNeeds;
